import { createContext } from "react";

export interface TourContextValue {
  startCurrentTour: () => void;
  hasTourForCurrentRoute: boolean;
  // True while a tour is actively showing. Components that hide tour step
  // targets (e.g. the collapsible filter sidebar) use this to force their
  // content visible so steps don't die on TARGET_NOT_FOUND.
  isTourRunning: boolean;
}

export const TourContext = createContext<TourContextValue>({
  startCurrentTour: () => {},
  hasTourForCurrentRoute: false,
  isTourRunning: false,
});
